import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { logOut } from '../../redux/reducers/authSlice';
import { resetIncident } from '../../redux/store';
import processImage from '../../assets/images/process.png';
import './HomeScreen.css';

const HomeScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleNewIncident = () => {
    dispatch(resetIncident());
    navigate('/incident/create');
  };

  const handleSignOut = async () => {
    await dispatch(logOut());
    navigate('/login');
  };

  return (
    <div className="home-container">
      <div className="home-header-container">
        <img 
          src={processImage} 
          alt="UPtime Process" 
          className="home-hero-image" 
        />
      </div>
      
      <div className="home-button-container">
        <Button 
          className="home-incident-button" 
          type="primary"
          size="large"
          onClick={handleNewIncident}
          block
        >
          CREATE AN INCIDENT
        </Button>
      </div>
      
      <Button 
        className="home-sign-out-button" 
        type="text"
        onClick={handleSignOut}
      >
        Sign Out
      </Button>
      
      <div className="home-version">
        {/* Version component placeholder - will add proper version later */}
        <span className="version-text">v1.0.0</span>
      </div>
    </div>
  );
};

export default HomeScreen;